var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass:
        "d-flex flex-column flex-sm-row gap-2 justify-content-end m-0 w-100 actionmanagement",
      attrs: { id: "post-action-buttons-form-" + _vm.postPrivateCode },
    },
    [
      _vm._t("csrf"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-center gap-2 w-100 my-3",
        },
        [
          _vm.enabledButtons.includes("publish")
            ? _c(
                "div",
                { staticClass: "flex-fill d-flex justify-content-center" },
                [
                  _c("ui-button", {
                    attrs: {
                      label: _vm.i18n.publish,
                      disabled: _vm.isPublishDisabled,
                      "icon-position": "top",
                      appearance: "primary",
                      "button-type": "blank",
                      size: "extra-small",
                      "font-weight": "semibold",
                    },
                    on: { click: _vm.publishPost },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon-top",
                          fn: function () {
                            return [_c("svg-publish")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1426346803
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enabledButtons.includes("suspend")
            ? _c(
                "div",
                { staticClass: "flex-fill d-flex justify-content-center p-0" },
                [
                  _c("ui-button", {
                    attrs: {
                      label: _vm.i18n.suspend,
                      disabled: _vm.suspendPostButtonDisabled,
                      "icon-position": "top",
                      appearance: "primary",
                      "button-type": "blank",
                      size: "extra-small",
                      "font-weight": "semibold",
                    },
                    on: { click: _vm.suspendPost },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon-top",
                          fn: function () {
                            return [_c("svg-suspend")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1091263168
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.enabledButtons.includes("review") &&
          _vm.enabledButtons.includes("edit")
            ? _c(
                "div",
                { staticClass: "flex-fill d-flex justify-content-center p-0" },
                [
                  _c("ui-button", {
                    attrs: {
                      href: _vm.editLink,
                      label: _vm.i18n.edit,
                      disabled: _vm.editPostButtonDisabled,
                      "icon-position": "top",
                      appearance: "primary",
                      "button-type": "blank",
                      size: "extra-small",
                      "font-weight": "semibold",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon-top",
                          fn: function () {
                            return [_c("svg-edit-pen")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1009764672
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-fill d-flex justify-content-center p-0" },
            [
              _c("ui-button", {
                attrs: {
                  label: _vm.i18n.delete,
                  disabled: _vm.deletePostButtonDisabled,
                  icon: "fa fa-trash-o fa-2x mr-1 icoblock",
                  "icon-position": "top",
                  appearance: "primary",
                  "button-type": "blank",
                  size: "extra-small",
                  "font-weight": "semibold",
                },
                on: { click: _vm.deletePost },
                scopedSlots: _vm._u([
                  {
                    key: "icon-top",
                    fn: function () {
                      return [_c("svg-trash", { attrs: { size: 24 } })]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column flex-md-row gap-2 w-100 w-md-auto mt-2 mt-md-0",
        },
        [
          _vm.enabledButtons.includes("duplicate")
            ? _c(
                "div",
                { staticClass: "col-sm pt-2" },
                [
                  _c("ui-button", {
                    attrs: {
                      appearance: "primary",
                      label: _vm.i18n.duplicate,
                      "button-type": "outline",
                      disabled: _vm.duplicatePostButtonDisabled,
                      block: "",
                    },
                    on: { click: _vm.duplicatePost },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enabledButtons.includes("promote")
            ? _c(
                "div",
                {
                  class: [
                    "pt-2",
                    _vm.oneImageFreeAdAlert ? "col-md" : "col-sm",
                  ],
                },
                [
                  _c("ui-button", {
                    attrs: {
                      icon: _vm.oneImageFreeAdAlert
                        ? "fa fa-unlock fa-lg mr-2"
                        : null,
                      "icon-position": _vm.oneImageFreeAdAlert ? "left" : null,
                      href: _vm.promoteLink,
                      appearance: "primary",
                      label: _vm.oneImageFreeAdAlert
                        ? _vm.i18n.activatePromoAndUnlockImages
                        : _vm.i18n.promote,
                      "button-type": "fill",
                      disabled: _vm.promotePostButtonDisabled,
                      block: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enabledButtons.includes("review")
            ? _c(
                "div",
                {
                  class: [
                    "pt-2",
                    _vm.oneImageFreeAdAlert ? "col-md" : "col-sm",
                  ],
                },
                [
                  _c("ui-button", {
                    attrs: {
                      href: _vm.reviewLink,
                      appearance: "primary",
                      label: _vm.i18n.review,
                      "button-type": "fill",
                      block: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enabledButtons.includes("renew_promotion")
            ? _c(
                "div",
                {
                  class: [
                    "pt-2",
                    _vm.oneImageFreeAdAlert ? "col-md" : "col-sm",
                  ],
                },
                [
                  _c("ui-button", {
                    attrs: {
                      icon: _vm.oneImageFreeAdAlert
                        ? "fa fa-unlock fa-lg mr-2"
                        : null,
                      "icon-position": _vm.oneImageFreeAdAlert ? "left" : null,
                      href: _vm.renewPromoLink,
                      disabled: _vm.promotePostButtonDisabled,
                      appearance: "primary",
                      label: _vm.oneImageFreeAdAlert
                        ? _vm.i18n.renewPromoAndUnlockImages
                        : _vm.i18n.renewPromotion,
                      "button-type": "fill",
                      block: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enabledButtons.includes("pay_now")
            ? _c(
                "div",
                { staticClass: "col-sm pt-2" },
                [
                  _c("ui-button", {
                    attrs: {
                      icon: _vm.oneImageFreeAdAlert
                        ? "fa fa-unlock fa-lg mr-2"
                        : null,
                      "icon-position": _vm.oneImageFreeAdAlert ? "left" : null,
                      href: _vm.payNowLink,
                      disabled: _vm.promotePostButtonDisabled,
                      appearance: "primary",
                      label: _vm.payNowButtonLabel,
                      "button-type": "fill",
                      block: "",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enabledButtons.includes("create_similar")
            ? _c("create-similar", {
                attrs: {
                  "init-create-similar-url": _vm.createSimilarLink,
                  "url-account-ads": _vm.accountAdsLink,
                  "post-private-code": _vm.postPrivateCode,
                  "can-create-similar": _vm.permissions.your_posts,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }